import {SyncAcknowledgement, SyncResult} from '../types';

export function hasSyncSnapshot(result: SyncAcknowledgement): result is SyncResult {
  return Array.isArray(result.tickets) && typeof result.last_sync === 'string'
    && typeof result.failed === 'number' && (result.warning === null || typeof result.warning === 'string');
}